export default __webpack_public_path__ + "static/consistent-header-page-level-messages-49b8ed3a888f6015953807d962eb4c5c.png";